<template>
  <ProSpaceModal
    v-model="localModelValue"
    ref="modalPeriod"
    class="modal-period"
    :withoutClose="disabledClose"
    :disabledCancel="disabledClose"
    @apply="applyCurrentPeriod"
    @close="closeModal"
    icon="parameters"
    width="405"
    height="450"
    :iconWidth="20"
    :closeOnEscape="!isDisabled"
    :disabledApply="isDisabled"
    :restoreResize="true"
    :title="$t('selectPeriod')"
    :cancelTxt="$t('closeTxt')"
    :applyTxt="$t('selectTxt2')"
  >
    <ProSpaceGeoLayout>
      <template #top>
        <ProSpaceHLayout
          :gap="10"
          :class="['modal-period__header prospace-scrollbar', { 'modal-period__header--loading': loadingOpenPeriods }]"
          style="padding: 10px;"
        >
          <Skeleton v-if="loadingOpenPeriods && !openPeriods.length" v-for="i in 3" height="60px" width="115px" />
          <div
            v-if="!loadingOpenPeriods && canAddPeriod"
            :class="['modal-period__header-item', {'p-highlight': addPeriodFocused }]"
            :style="getPeriodWidth"
            @click="addPeriod"
          >
            <ProSpaceAction
              ref="changePeriodUsers"
              class="modal-period__new-btn"
              :text="$t('newTxt')"
              icon="plus"
              :gap="5"
              gray
              @click.prevent
            />
          </div>
          <div
            v-if="!loadingOpenPeriods"
            :ref="`active-period-${index}`"
            :data-index="index === currentActivePeriodIndex"
            :class="['modal-period__header-item', {'p-highlight': currentActivePeriodIndex === index}]"
            :style="getPeriodWidth"
            v-for="(period, index) in openPeriods"
            :key="period.name"
            @click="setActivePeriod(period, index)"
          >
            <span class="modal-period__header-period">
              {{ period.name }}
            </span>
            <ProSpaceTag
              type="teal"
              :text="$t('period_opened')"
              bordered
              style="height: 20px"
            />
          </div>
        </ProSpaceHLayout>
      </template>
      <template #center>
        <ProSpaceGeoLayout class="modal-period__body">
          <template #top>
            <ProSpaceFilterPanel
              ref="filter-panel"
              class="modal-period__filter"
              :searchPlaceholder="$t('searchTxt')"
              filter-model="name"
              style="padding: 0 10px"
              no-mounted-request
            >

            </ProSpaceFilterPanel>
          </template>
          <template #center>
            <ProSpaceMainGrid
              ref="grid"
              :service="marsPeriodService"
              @selected-change="setInActivePeriod"
              :default-filter="defaultFilter"
              getMethod="grid"
              selectionMode="single"
              :customHeightRow="31"
              isHeadHide
              class="modal-period__list"
              :class="{'modal-period__list--loading' : loadingClosedPeriods}"
              @loaded="setPeriods"
              defaultSortField="id"
              defaultSortOrder=2
              no-mounted-request
            >
              <template #columns>
                <Column field="name" header="Name" class="modal-period__list-item">
                  <template #body="field">
                    <ProSpaceTag
                      type="draft"
                      :text="$t('period_closed')"
                      bordered
                      style="height: 20px"
                    />
                    <span class="modal-period__list-period">
                    {{ field.data?.name }}
                  </span>
                  </template>
                </Column>
              </template>
              <template #empty>
                <ProSpaceEmptyGrid
                  v-if="!loadingClosedPeriods"
                  icon="error-message"
                  :title="$t('noDataTitle')"
                  :text="$t('noDataTxt')"
                />
              </template>
            </ProSpaceMainGrid>
          </template>
        </ProSpaceGeoLayout>
      </template>
    </ProSpaceGeoLayout>
  </ProSpaceModal>
  <ProSpaceModal
    v-model="showApply"
    v-if="showApply"
    is-custom
    class="modal-period-message"
    width="320"
    :cancelTxt="$t('cancelTxt')"
    :applyTxt="$t('applyTxt')"
  >
    <ProSpaceMessage
      v-model="showApply"
      type="primary"
      icon="message-success"
      colorIcon="white"
      :title="$t('new_period')"
      @close="onCloseError"
    >
      <template #body>
        <ProSpaceHLayout justify-content="center">
          <p class="text-color-gray text-center">{{ $t('promptTxtPeriod') }} <span class="text-color-accent">{{ nextPeriod }}</span>?</p>
        </ProSpaceHLayout>
      </template>
      <template #controls>
        <ProSpaceHLayout justify-content="center" :gap="5">
          <ProSpaceButton
            type="tertiary"
            :label="$t('cancelTxt')"
            @click="onCloseError"
          />
          <ProSpaceButton
            type="primary"
            icon="check"
            :label="$t('confirmTxt')"
            @click="applyPeriod"
          />
        </ProSpaceHLayout>
      </template>
    </ProSpaceMessage>
  </ProSpaceModal>
</template>

<script>
import {
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceButton,
  ProSpaceHLayout,
  ProSpaceAction,
  ProSpaceIcon,
  ProSpaceTag,
  ProSpaceMainGrid,
  ProSpaceEmptyGrid,
  ProSpaceFilterPanel,
  ProSpaceMessage,
} from "@prospace/prospace-components-library";
import { MarsPeriodService } from "../../../services/MarsPeriodService.js";
import Column from "primevue/column";
import { mapGetters } from "vuex";
import accessMixin from "../../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import Skeleton from 'primevue/skeleton';

export default {
  name: "ModalPeriods",
  mixins: [accessMixin],
  components: {
    ProSpaceModal,
    ProSpaceGeoLayout,
    ProSpaceButton,
    ProSpaceHLayout,
    ProSpaceAction,
    ProSpaceIcon,
    ProSpaceTag,
    ProSpaceMainGrid,
    ProSpaceEmptyGrid,
    Column,
    ProSpaceFilterPanel,
    ProSpaceMessage,
    Skeleton
  },
  props: {
    modelValue: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    disabledClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marsPeriodService: new MarsPeriodService(),
      currentMarsPeriod: 1,
      openPeriods: [],
      currentActivePeriodIndex: null,
      isDisabled: true,
      showApply: false,
      addPeriodFocused: false,
      nextPeriod: null,
      loadingOpenPeriods: true,
      loadingClosedPeriods: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.grid.getRecords();
    })
  },
  methods: {
    async setPeriods() {
      this.loadingClosedPeriods = false;
      this.openPeriods = await this.getOpenPeriods(); // 1
      this.nextPeriod = this.getNextPeriod();

      if (this.period && Object.keys(this.period).length > 0) { // set default period on load
        this.setPeriod(this.period);
        if ((this.period.status).toLowerCase() === 'closed') {
          this.setInActivePeriod(this.period);
        } else if ((this.period.status).toLowerCase() === 'opened') {
          const index = this.openPeriods.findIndex(p => p.name === this.period.name);
          this.setActivePeriod(this.period, index);
        }
      }
    },
    async getOpenPeriods() {
      const params = `$filter=((((tolower(status) eq 'opened'))) and (((disabled eq false))))&$orderby=id asc&$top=200&$skip=0`;
      let records = [];
      await this.marsPeriodService.grid(params)
        .then((res) => {
          records = res.data.records;
        })
        .finally(() => {
          this.loadingOpenPeriods = false;
        });

      return records;
    },
    setPeriod(period) {
      if (Object.keys(period).length > 0) {
        const oldPeriod = this.currentMarsPeriod.name;
        this.currentMarsPeriod = period;
        this.isDisabled = this.period?.name
          ? period.name === this.period?.name
          : period.name === oldPeriod;
      }
    },
    applyCurrentPeriod() {
      let marsPeriod = this.currentMarsPeriod
      if (marsPeriod.data) {
        marsPeriod = this.currentMarsPeriod.data
      }
      this.$store.dispatch("marsPeriodStore/setMarsPeriod", marsPeriod);
      this.closeModal();
    },
    setActivePeriod(period, index) {
      this.setPeriod(period);
      const selected = this.$refs.grid?.clickedItem;
      this.currentActivePeriodIndex = index;
      if (selected) {
        this.$nextTick(() => {
          this.$refs.grid.clickedItem = null;
        });
      }
      this.addPeriodFocused = false;
    },
    addPeriod() {
      this.addPeriodFocused = true;
      this.currentActivePeriodIndex = null;
      this.$refs.grid.clickedItem = null;
      this.showApplyModal();
    },
    setInActivePeriod(period) {
      period = period.data || period;
      this.setPeriod(period);
      const selected = this.$refs.grid.clickedItem;
      if (selected) {
        this.$nextTick(() => {
          this.$refs.grid.clickedItem = period.id;
        });
      } else {
        this.currentActivePeriodIndex = period.id || null;
        this.$refs.grid.clickedItem = period.id || null;
      }
      this.addPeriodFocused = false;
    },
    showApplyModal() {
      this.showApply = true;
    },
    applyPeriod() {
      const period = {
        name: this.getNextPeriod(),
        status: 'opened'
      }
      this.marsPeriodService.create(period).then(res => {
        if (res && res.success) {
          const newPeriod = res.data[0];
          this.openPeriods.push(newPeriod);
          this.currentMarsPeriod = newPeriod;
          this.onCloseError();
          this.closeModal();
          this.$store.dispatch("marsPeriodStore/setMarsPeriod", this.currentMarsPeriod);
        }
      });
    },
    closeModal() {
      this.$store.commit("marsPeriodStore/SET_PERIODMODALSTATE", false);
    },
    onCloseError() {
      this.showApply = false;
    },
    getNextPeriod() {
      let periods = [];
      const name = (p) => p.name?.trim().split(/\s+/);
      const closedPeriods = this.$refs.grid.records;
      let nextPeriod = "";
      if (this.openPeriods.length > 0) {
        periods = this.openPeriods.map(p => {
          return {
            m: Number(name(p)[0].substring(1, 3)),
            y: Number(name(p)[1])
          }
        });
      }
      if (closedPeriods.length > 0) {
        periods = periods.concat(
          closedPeriods.map(p => {
            return {
              m: Number(name(p)[0].substring(1, 3)),
              y: Number(name(p)[1])
            }
          })
        );
      }
      if (periods.length > 0) {
        const months = periods.map(p => p.m);
        const years = periods.map(p => p.y);
        const maxYears = Math.max(...years);
        const maxYearsPeriod = periods.filter(p => p.y === maxYears);
        let maxMonth = Math.max(...months);
        const lastPeriod = this.lastPeriodFunc(maxMonth, maxYearsPeriod);
        const { y: lpYear, m: lpMonth } = lastPeriod;
        const nextMonth = lpMonth + 1 < 10 ? `0${lpMonth + 1}` : lpMonth + 1;
        nextPeriod = lpMonth < 13 ? `P${nextMonth} ${lpYear}` : `P01 ${lpYear + 1}`;
      } else {
        nextPeriod = "P08 2025";
      }

      return (nextPeriod).toUpperCase();
    },
    lastPeriodFunc(max, maxYearsPeriod) {
      const res = maxYearsPeriod.find(p => p.m === max);
      if (!res && max > 1) {
        return this.lastPeriodFunc(max - 1, maxYearsPeriod);
      } else {
        return res;
      }
    },
    submitFilter({ filter, search }) {
      this.$refs.grid.submitFilter(filter, search);
    },
  },
  computed: {
    ...mapGetters({
      access: "securityRoleAccess/access",
      period: "marsPeriodStore/getMarsPeriod",
    }),
    defaultFilter() {
      return {
        status: { and: ["closed"] },
        disabled: { and: [false] },
      };
    },
    localModelValue: {
      get() {
        return this.modelValue;
      },
      set(newVal) {
        this.$store.commit("marsPeriodStore/SET_PERIODMODALSTATE", newVal);
      },
    },
    getPeriodWidth() {
      return `min-width: calc(330px / ${this.openPeriods.length + 1});`;
    },
    canAddPeriod() {
      return this.checkAccess("marsPeriod-addPeriod");
    },
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.loadRoleAccess();
  //   });
  // }
};
</script>

<style lang="scss">
.modal-period {
  & .p-dialog-content {
    padding: 0;
  }
  .prospace-geo-layout__top {
    padding: 10px;
  }
  &__header {
    position: relative;
    padding-bottom: 0px !important;
    background: var(--prospace-ui-bg-layout);
    border-radius: 5px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    overflow: auto;
    border-radius: 5px;
    &-item {
      height: 60px;
      flex: 1 0 92px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      background: var(--prospace-ui-card);
      border-radius: 5px;
      border: 1px solid transparent;
      cursor: pointer;
      &.p-highlight {
        border: 1px solid var(--blue-500); //#2196F3
      }
      .prospace-action {
        font-weight: 500;
        font-size: 14px;
        max-width: 90px;
        position: relative;
        left: -5px;
      }
      .prospace-action-text {
        color: var(--prospace-text-main);
      }
      .prospace-icon {
        background-color: var(--blue-500); //#2196F3
      }
    }
    &-period {
      font-size: 14px;
      font-weight: 500;
      color: var(--prospace-text-main);
      margin-bottom: 5px;
    }
    &--loading {
      height: 84px !important;
      overflow: hidden;
    }
    // отступ для скролла справа
    &.prospace-scrollbar {
      &::-webkit-scrollbar {
        height: 10px;
      }
      &::-webkit-scrollbar-track-piece {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        //box-shadow: inset 0 0 10px 10px #CFD6E2;
        border: solid 3px transparent;
        background: transparent;
      }
      &::-webkit-scrollbar-track {
        border: 3px solid transparent;
      }
    }
    //-- отступ для скролла справа
  }
  &__body {
    .prospace-geo-layout__center.prospace-scrollbar {
      overflow: hidden;
    }
    .prospace-geo-layout__top {
      padding-top: 0;
      border-bottom: 1px solid var(--prospace-ui-border-color);
    }
    // отступ для скролла снизу
    .prospace-geo-layout__center {
      &.prospace-scrollbar {
        &::-webkit-scrollbar {
          width: 10px;
        }
        &::-webkit-scrollbar-track-piece {
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          //box-shadow: inset 0 0 10px 10px var(--prospace-text-light-gray);
          border: solid 3px transparent;
          background: transparent;
        }
        &::-webkit-scrollbar-track {
          border: 3px solid transparent;
          background: var(--prospace-ui-text-light-gray);
        }
        &::-webkit-scrollbar-track-piece {
          background: var(--prospace-ui-bg-layout);
        }
      }
    }
    //-- отступ для скролла снизу
  }
  .prospace-scrollbar {
    &::-webkit-scrollbar-thumb {
      box-shadow: inset 0 0 10px 10px var(--prospace-text-light-gray);
    }
  }
  &__search {
    width: 100%;
  }
  &__list {
    width: 100%;
    height: 100%;
    background: var(--prospace-ui-bg-layout);
    padding-top: 5px;
    padding-left: 10px;
    padding-right: 6px;
    &-period {
      font-size: 14px;
      font-weight: 500;
      color: var(--prospace-text-main);
      margin-left: 30px;
    }
    .p-selectable-row {
      padding: 0 10px !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      min-width: 100%;
      &:not(:first-child) {
        border-top: 1px solid var(--prospace-ui-row-border)!important;
      }

      &.p-highlight {
        border: 1px solid #2196f3!important;
      }
    }
    &-item {
      display: flex;
      align-items: center;
    }
    //.p-selectable-row {
    //  padding: 0!important;
    //  margin: 0!important;
    //  border: none!important;
    //  &:not(:first-child) {
    //    border-top: 2px solid #f3f3f3!important;
    //  }
    //}
  }
  &__filter  {
    padding-left: 0 !important;
    padding-right: 0 !important;
    .prospace-filter-panel__second-row {
      padding: 0;
      background-color: inherit;
      border-bottom: none;
      & > .prospace-h-layout {
        width: 100% !important;
      }
    }
    .prospace-filter-panel__filters-container {
      display: none !important;
    }
  }
  &__loading {
    left: 0;
    position: absolute;
    height: 50px;
    width: 100%;
  }
  .main-grid {
    &__loading {
      height: 100%;
      padding: 0 !important;
      left: 0;
      top: 0;
    }
    &__empty {
      border-top: none;

      .p-datatable .p-datatable-tbody > tr > td {
        border: none;
      }
    }
    &__without-grey {
      .p-datatable .p-datatable-tbody > tr {
        border-bottom: none;
      }
    }
    .p-datatable .p-datatable-tbody {
      overflow: hidden !important;
    }
    .p-datatable-loading-overlay {
      overflow: visible !important;
    }
  }
  .modal-period__list--loading {
    min-height: 200px;
  }
}
.modal-period-message {
  min-width: 0;
  overflow: hidden;
  border-right: 5px;
  .prospace-message {
    width: auto;
  }
  .icon-message-success {
    background-color: #ffffff;
  }
  .text-center {
    max-width: 250px;
    margin: 0 auto;
    text-align: center;
  }
}
</style>
